/* 这个跟 quality_report_base 基本是一样的，可能是之后上报协议多了之后，用这个文件名做个区分 */
import Env from 'common/env.js';
import Dom from '../base/mdom.js';
import _qualityBase from './quality_report_base.js';
let exportData;
if(!Env.isCSR) {
    var wxBridge    = null;
    var WXGAME      = Dom.window.WXGAME        || {};
    var qualityBase     = WXGAME.baseQualityReport || _qualityBase;
    /**
     * 这个是带verify reportGameWeb功能的运行逻辑能力。
     *
     * @param {*} type
     * @param {*} target
     * @param {*} params
     * @returns
     */
    function StartLogic(type,target,params){
        return qualityBase.StartLogic(type,target,params,wxBridge);
    }

    /**
     * 专门抽象出来 ，为写js逻辑用的。
     *
     * @param {*} target
     * @param {*} params
     * @returns
     */
    function StartRuner(target,params){
        var type = qualityBase.LOGIC_CONST.TypeTextEnum.LOGIC;
        return qualityBase.StartLogic(type,target,params,wxBridge);
    }

    exportData = {
        StartLogic  : StartLogic,
        StartRuner  : StartRuner,
        LOGIC_CONST : qualityBase.LOGIC_CONST
    }
}else{
    exportData = {}
}

export default exportData;
